<template>
  <div>
    <h1 class="ui header dmcs" v-once v-html="title"></h1>
    <table class="ui celled table">
      <thead>
      <tr><th>
          <div class="ui icon input">
            <input class="prompt" type="text" placeholder="Start typing.../Zacznij pisać..."
                   v-model="searchTerm">
            <i class="inverted circular search link icon"></i>
          </div>
      </th>
      </tr></thead>
      <tbody>
      <tr v-if="pages.length" v-for="page in pages" :key="page.title">
        <td v-if="page.visible"><a :href="'/' + page.href">{{page.title}}</a></td>
      </tr>
      </tbody>
    </table>
    <h2 class="ui header dmcs">Studia podyplomowe</h2>
    <a href="ak-pod/index.html">architektura Komputerow (Informatyka dla nauczycieli)</a><br/>
    <a href="soc-pod/index.html">Układy reprogramowalne i SoC</a>
    <br/>
    <a href="podyplomowe_smtm/index.html">Systemy mobilne i techniki multimedialne</a>
    <br/>
    <a href="http://www.kapitalludzki.p.lodz.pl/"><img src="../assets/podyplomowe.jpg" border="0"/></a><br/>

    <h2> Some useful information </h2>
    <a href="tk/UNIXhelp1.3/Pages/index.html">UNIX help for users</a><br/>
    <a href="pd/tcl8.3/index.htm"> Tcl/Tk 8.3 reference manual</a><br/>

    <a href="utils"> Downloads </a><br/>
  </div>
</template>

<script>
import data from '../assets/data';

export default {
  name: 'Przedmioty',
  data() {
    return {
      title: data.general.title,
      searchTerm: '',
    };
  },
  computed: {
    pages() {
      const sortedPages = data.pages.sort((a, b) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      });
      if (this.searchTerm.length === 0) {
        return sortedPages;
      }
      return sortedPages.filter(item => (item.title.includes(this.searchTerm)
                                || item.title.toLowerCase().includes(this.searchTerm)));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  input.prompt[type="text"]{
    width:200px;
  }
  .dmcs {
    font-family: Verdana, Arial, Helvetica;
    font-size: 14pt !important;
    margin-top: 6px !important;
    margin-bottom: 6px !important;
    color: #a21100 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Przedmioty.vue